import { render, staticRenderFns } from "./RegionOlympic.vue?vue&type=template&id=54d58294&scoped=true&"
import script from "./RegionOlympic.vue?vue&type=script&lang=js&"
export * from "./RegionOlympic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d58294",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
